module.exports = __webpack_public_path__ + "img/16581242_S.918c777d.png";